import { tokens } from '@welbe/web-design-system'
import styled from 'styled-components'

export const Container = styled.div`
	position: relative;
	left: 0;
	animation: fadeSlide 0.4s;

	@keyframes fadeSlide {
		0% {
			left: -70px;
			opacity: 0;
		}
		100% {
			opacity: 1;
			left: 0;
		}
	}

	svg {
		color: ${tokens.color_gray_dark};
	}
`

export const ContainerProgressBar = styled.div`
	padding: 21px 0;
`

export const ContainerNavBar = styled.div`
	div {
		display: flex;
		justify-content: space-between;
		margin: 0;
	}

	span {
		margin: 0;
	}

	@media (max-width: 768px) {
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		gap: 21px;

		label {
			max-width: 100%;
		}
	}

	@media (max-width: 390px) {
		padding: 24px 0;
	}
`

export const ContainerSkeleton = styled.div`
	display: flex;
	flex-direction: column;
	gap: 21px;
	margin-top: 21px;
`

export const Title = styled.h2`
	font-family: ${tokens.font_family_primary};
	color: ${tokens.color_primary};
	font-weight: 600;
	text-align: center;
	font-size: 20px;
	margin-top: 27px;
	margin-bottom: 27px;

	@media (max-width: 768px) {
		font-size: 16px;
		margin-top: 0;
	}
`

export const Text = styled.p`
	font-family: ${tokens.font_family_primary};
	color: ${tokens.color_gray_dark};
	font-weight: 600;
	text-align: left;
	font-size: 16px;
	margin-bottom: 27px;
`
